import React from 'react';
import { Button, Form } from 'semantic-ui-react';

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
        };

        this.onFilterData = this.onFilterData.bind(this);
    }


    onFilterData() {
        this.props.onFilterData(this.state.name);
    }


    render() {
        return (
            <div>{!this.props.noBreak && <div><br /></div>}
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Naziv predmeta</label>
                            <input
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                name="name"
                                placeholder="Unesite naziv predmeta"
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                    <Button color="blue" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <Button color="blue" basic="true" onClick={this.props.filtersOff}>Odustani
                    </Button>
                </Form>
                {!this.props.noBreak && <br />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/Filters.js